import Home from 'views/App/Home/Home.jsx'
import Agenti from 'views/App/Agenti/Agenti.jsx'
import Pubblicita from 'views/App/Pubblicita/Pubblicita.jsx'
import Calendario from 'views/App/Calendario/Calendario.jsx'
import CalendarioGiorno from 'views/App/CalendarioGiorno/CalendarioGiorno.jsx'
import Clienti from 'views/App/Clienti/Clienti.jsx'
import Promemoria from 'views/App/Promemoria/Promemoria.jsx'
import Coupon from 'views/App/Coupon/Coupon.jsx'

// material-ui-icons
import DashboardIcon from 'material-ui-icons/Dashboard'
import Group from 'material-ui-icons/Group'
import ThumbUp from 'material-ui-icons/ThumbUp'
import DateRange from 'material-ui-icons/DateRange'
import Event from 'material-ui-icons/Event'
import RecentActors from 'material-ui-icons/RecentActors'
import Alarm from 'material-ui-icons/Alarm'
import CardGiftcard from 'material-ui-icons/CardGiftcard'

var dashRoutes = [
  {
    path: '/home',
    name: 'Homepage',
    icon: DashboardIcon,
    component: Home,
  },
  {
    path: '/agenti',
    name: 'Agenti',
    icon: Group,
    component: Agenti,
  },
  {
    path: '/pubblicita',
    name: 'Pubblicità',
    icon: ThumbUp,
    component: Pubblicita,
  },
  {
    path: '/clienti',
    name: 'Clienti',
    icon: RecentActors,
    component: Clienti,
  },
  {
    path: '/calendario',
    name: 'Calendario',
    icon: DateRange,
    component: Calendario,
  },
  {
    path: '/impegni-giorno',
    name: 'Impegni del giorno',
    icon: Event,
    component: CalendarioGiorno,
  },
  {
    path: '/promemoria',
    name: 'Promemoria',
    icon: Alarm,
    component: Promemoria,
  },
  {
    path: '/coupon',
    name: 'Coupon',
    icon: CardGiftcard,
    component: Coupon,
  },
  { redirect: true, path: '/', pathTo: '/home', name: 'Home' },
]

export default dashRoutes



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx